module.exports = __webpack_public_path__ + "static/img/pxjl.af05955.png";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial/pxjl.png
// module id = 4FRp
// module chunks = 14